import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);
    
    var url_string = window.location.href;
    var url = new URL(url_string);
    
    this.state = {
      query: url.searchParams.get("query"),
      exact: false,
      fromUser: url.searchParams.get("fromUser"),
      isExactDate: false,
      exactDate: '',
      sinceDate: '',
      untilDate: '',
      filterReplies: false,
    };
    this.queryString = '';
    this.onFieldChange = this.onFieldChange.bind(this);
    this.copy = this.copy.bind(this);
    this.submit = this.submit.bind(this);
  }
  
  onFieldChange(event) {
    const target = event.target;
    const name = target.name;
    const value = (target.type == 'checkbox') ? target.checked : target.value;
    if (target.name == 'isExactDate') {
      var copy = '';
      if (this.state.isExactDate) { // Exact to Since/Until
        if ((this.state.exactDate != '') && (true || (this.state.sinceDate == ''))) {
          //alert('Exact');
          copy = this.state.exactDate;
        } else {
          copy = this.state.sinceDate;
        }
        this.setState({
          [name]: value,
          sinceDate: copy
        });
      } else { // Since/Until to Exact
        if ((this.state.sinceDate != '') && (true || (this.state.exactDate == ''))) {
          //alert('Not Exact');
          copy = this.state.sinceDate;
        } else {
          copy = this.state.exactDate;
        }
        this.setState({
          [name]: value,
          exactDate: copy
        });
      }
    } else {
      this.setState({
        [name]: value
      });
    }
  }
  
  copy() {
    document.getElementById('queryString').select();
    document.execCommand('copy');
    alert('Copied query string.');
  }
  
  submit(e) {
    const url = "http://twitter.com/search?f=tweets&vertical=default&q=" + this.queryString;
    //alert(url);
    //https://twitter.com/search?f=tweets&vertical=default&q=QUERY&src=typd
    window.location.href = url;
    e.preventDefault();
  }
  
  formatSearchDate(dateString) {
    let simple = dateString.replace(/(\-|\s|\/)+/g, '');
    if (simple.match(/^\d+$/)) {
      if (simple.length >= 7) {
        simple = simple.slice(0,4) + '-' + simple.slice(4,6) + '-' + simple.slice(6);
      } else if (simple.length >= 5) {
        simple = simple.slice(0,4) + '-' + simple.slice(4);
      }
    } else {
      simple = '';
    }
    return simple;
  }
  
  render() {
    this.queryString = "";
    if (this.state.query) {
      if (this.state.exact) {
        this.queryString += "\"" + this.state.query.trim() + "\"";
      } else {
        this.queryString += this.state.query.trim();
      }
    }
    if (this.state.fromUser) {
      this.queryString += ' from:' + this.state.fromUser.replace(/\s+/g, '');
    }
    if (this.state.isExactDate) {
      if (this.state.exactDate) {
        var temp = this.formatSearchDate(this.state.exactDate);
        if (temp.length == 10) {
          var temp2 = Date.parse(temp);
          if (!isNaN(temp2)) {
            temp2 = (new Date(temp2.valueOf() + 86400*1000)).toISOString().slice(0,10);
          } else {
            temp2 = ''
          }
        } else {
          temp2 = '';
        }
        this.queryString += ' since:' + temp;
        if (temp2) {
          this.queryString += ' until:' + temp2;
        }
      }
    } else {
      if (this.state.sinceDate) {
        this.queryString += ' since:' + this.formatSearchDate(this.state.sinceDate);
      }
      if (this.state.untilDate) {
        this.queryString += ' until:' + this.formatSearchDate(this.state.untilDate);
      }
    }
    if (this.state.filterReplies) {
      this.queryString += ' -filter:replies';
    }
    this.queryString = this.queryString.trim();
    
    return (
      <div className="App">
        <header className="App-header">
          <h1 className="App-title">Twitter Search</h1>
        </header>
        <p className="App-intro">
          <form onSubmit={this.submit} style={{textAlign: 'right', margin: 'auto', width: 'auto', display: 'table'}}>
            Query: <input type='text' name='query' value={this.state.query} onChange={this.onFieldChange} autoFocus={true} /><br/>
            <input type='checkbox' name='exact' checked={this.state.exact} onChange={this.onFieldChange} /> Exact Query<br/>
            <input type='submit' value='Search' /><br/><br/>
            From User: <input type='text' name='fromUser' value={this.state.fromUser} onChange={this.onFieldChange} /><br/><br/>
            <input type='checkbox' name='isExactDate' checked={this.state.isExactDate} onChange={this.onFieldChange} /> Exact Date<br/>
            <div style={{display: (this.state.isExactDate) ? 'none' : 'block'}} >Since Date: <input type='text' name='sinceDate' value={this.state.sinceDate} onChange={this.onFieldChange} /><br/></div>
            <div style={{display: (this.state.isExactDate) ? 'none' : 'block'}} >Until Date: <input type='text' name='untilDate' value={this.state.untilDate} onChange={this.onFieldChange} /><br/><br/></div>
            <div style={{display: (this.state.isExactDate) ? 'block' : 'none'}} >Date: <input type='text' name='exactDate' value={this.state.exactDate} onChange={this.onFieldChange} /><br/><br/></div>
            <input type='checkbox' name='filterReplies' checked={this.state.filterReplies} onChange={this.onFieldChange} /> Filter Out Replies<br/><br/>
            Search String: <input id='queryString' type='text' readonly='readonly' value={this.queryString} /><br /><input type='button' name='copy' value='Copy' onClick={this.copy} /><br />
          </form>
        </p>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js